module.exports = __webpack_public_path__ + "img/bp_giftbg_0001.68839220.png";